import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'groupFidelity',
    label: 'Group Fidelity',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
